<script setup lang="ts">
import { useCreateFreeDemoService, useGetStatusFreeDemoService } from '@/api/services.ts';
import { useAppStore } from '@/stores/app.ts';

const route = useRoute();
const appStore = useAppStore();

watch(
  () => route.query,
  async () => {
    const welcomeToOrganizer = route.query.welcome_to_organizer as string | null;

    if (welcomeToOrganizer) {
      const { data: dataFreeDemoService, error: errorFreeDemoService } = await useGetStatusFreeDemoService();

      if (dataFreeDemoService && !errorFreeDemoService && !dataFreeDemoService.success) {
        const { data, error } = await useCreateFreeDemoService();

        if (data && !error) {
          appStore.freeServiceDetail = data;
          appStore.isNewUserWelcomeModalOpen = true;
        }
      }
    }
  },
  { deep: true, immediate: true },
);
</script>

<template><span /></template>
